import React, { useState }from 'react'
import {
  useTranslate,
  useNotify
} from 'react-admin'
import LoadingButton from '@mui/lab/LoadingButton'
import CachedIcon from '@mui/icons-material/Cached';
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service';

export const UpdateRuleView = () => {
  const translate = useTranslate()
  const notify = useNotify()
  const [ loading,  setLoading ] = useState(false)

  const updateView = async () => {
    try {
      setLoading(true)
      const response = await businessRuleServices.updateRuleView()
      if (response){
        notify('ra.notification.success_update_view', {
          type: 'success'
        })
      }else {
        notify('ra.notification.already_update_view', {
          type: 'warning'
        })
      }
    } catch (error) {
      notify('ra.notification.error_update_view', {
        type: 'error'
      })
    }finally{
      setLoading(false)
    }
    
  }

  return (
    <LoadingButton
      loading={loading}
      onClick={updateView}
      startIcon={<CachedIcon />}
      style={{ padding: 0, margin: 0, marginLeft: '5px' }}
    >
      {translate(`ra.action.update_rule_view`)}
    </LoadingButton>
  )
}
